module.exports = __webpack_public_path__ + "static/media/login.91194a57.svg";